import React from "react";

const sizes = {
  xs: "text-xs font-medium",
  lg: "text-2xl font-medium md:text-[22px]",
  s: "text-base font-medium",
  "2xl": "text-[32px] font-medium md:text-3xl sm:text-[28px]",
  "3xl": "text-5xl font-medium md:text-[44px] sm:text-[38px]",
  md: "text-lg font-medium",
};

const Text = ({ children, className = "", as, size = "s", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-blue_gray-900_b2 font-poppins ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
